import { FilterButton, SelectColumnsButton, TopToolbar } from 'react-admin';

export const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <SelectColumnsButton />
  </TopToolbar>
);
